import { compose, withProps, withHandlers } from 'recompose'
import { connect } from 'react-redux'
import withEntity from '../../context/with-entity'
import { isAuctionPending, isAuctionLive, isAuctionClosed } from './utils'
import withTranslations from '../../core/withTranslations'
import AuctionDetail from '../../ui/views/auction-detail'
import capitalize from 'lodash/capitalize'
import { domains } from '../constants'
import {
  formatStartCloseTime,
  formatDateLongWithTime,
  formatDateLong
} from '../../core/dateFormater'
import { AUCTION_DETAIL_MODAL_TYPE } from './constants'
import { openAuctionDetailModal, closeAuctionDetailModal } from './actions'
import { getAuctionModalType, isAuctionDetailModalOpen } from './selectors'
import withResetModal from '../modal/withResetModal'

const withDomain = withProps(props => ({ domain: domains.AUCTIONS }))

const translations = withTranslations({
  startText: 'app:auction.start',
  closeText: 'app:auction.close',
  locationText: 'common:location',
  viewMapText: 'common:viewMap',
  charityText: 'app:auction.properties.charity',
  descriptionText: 'common:description',
  viewItemsText: 'app:auction.actionButtons.viewItems',
  saveEventText: 'app:auction.actionButtons.saveEvent',
  savedText: 'common:saved',
  shareText: 'common:share',
  haveGreatItemsText: 'app:auction.actionButtons.haveGreatItems',
  takeLookText: 'app:auction.actionButtons.takeLook',
  scheduleEventText: 'app:auction.scheduleEvent',
  auctionItemsText: 'app:auction.auctionItems',
  howToAttendEventText: 'app:auction.howToAttendEvent',
  askQuestionText: 'app:auction.askQuestion'
})

const mapStateToProps = (state, props) => {
  const auctionId = props.match.params.id
  const { auction } = props
  const isModalOpen = isAuctionDetailModalOpen(state)
  const modalType = getAuctionModalType(state)
  return {
    auctionId,
    auction,
    isModalOpen,
    modalType
  }
}
const withAuctionData = connect(mapStateToProps, {
  openAuctionDetailModal,
  closeAuctionDetailModal
})

const withFormattedProps = withProps(props => {
  const {
    entity,
    // translations
    locationText,
    viewMapText,
    charityText,
    descriptionText,
    savedText,
    shareText
  } = props
  return {
    auction: entity,
    eventDateFormatted: formatDateLong(new Date(entity.closeTime)),
    startDateFormatted: formatDateLongWithTime(new Date(entity.startTime)),
    closeDateFormatted: formatDateLongWithTime(new Date(entity.closeTime)),
    schedule: formatStartCloseTime(entity.startTime, entity.closeTime),
    charityName: entity.charity.name,
    charityUrl: `/charities/${entity.charity.id}`,
    showStateTag: !isAuctionPending(entity),
    showSaveIcon: !isAuctionClosed(entity),
    isAuctionSaved: false,
    isAuctionLive: isAuctionLive(entity),
    isAuctionClosed: isAuctionClosed(entity),
    isAuctionPending: isAuctionPending(entity),
    itemsLink: `/auctions/${entity.id}/items`,
    // translations
    locationText: capitalize(locationText),
    viewMapText: capitalize(viewMapText),
    charityText: capitalize(charityText),
    descriptionText: capitalize(descriptionText),
    savedText: capitalize(savedText),
    shareText: capitalize(shareText)
  }
})

const withModalActionsAndLinkTo = withHandlers({
  openSchedule: props => e => {
    e.preventDefault()
    props.openAuctionDetailModal(AUCTION_DETAIL_MODAL_TYPE.SCHEDULE)
  },
  openHowToAttend: props => e => {
    e.preventDefault()
    props.openAuctionDetailModal(AUCTION_DETAIL_MODAL_TYPE.HOW_TO_ATTEND)
  },
  openQuestions: props => e => {
    e.preventDefault()
    props.openAuctionDetailModal(AUCTION_DETAIL_MODAL_TYPE.QUESTIONS)
  },
  closeModal: props => e => {
    e && e.preventDefault()
    props.closeAuctionDetailModal()
  },
  linkToItems: props => e => {
    e.preventDefault()
    props.history.push(props.itemsLink)
  }
})

export const AuctionDetailEnhancer = compose(
  withDomain,
  withEntity,
  withFormattedProps,
  withAuctionData,
  withModalActionsAndLinkTo,
  withResetModal,
  translations
)

export default AuctionDetailEnhancer(AuctionDetail)



// WEBPACK FOOTER //
// ./src/services/auction/AuctionDetail.js